import React from 'react';
import { Link } from 'react-router-dom';

// Pitch Page - TEDx Style Presentation
const PitchPage = () => {
  const slides = [
    {
      type: 'title',
      title: '</AI_COVO>',
      subtitle: 'DIGITAL HUB SOCIALE',
      tagline: 'Colle Val d\'Elsa · Città dal 1592'
    },
    {
      type: 'question',
      title: 'Chi si occupa di loro?',
      content: 'Una generazione a cui è stato tolto quasi tutto quello che avevano i loro genitori.',
      highlight: 'Spazi comuni. Possibilità. Futuro.'
    },
    {
      type: 'problem',
      title: 'Il Problema',
      stats: [
        { number: '7', label: 'anni', desc: 'Età media del primo smartphone' },
        { number: '6+', label: 'ore/giorno', desc: 'Tempo medio sullo schermo' },
        { number: '0', label: 'spazi', desc: 'Alternative reali offerte' }
      ]
    },
    {
      type: 'contrast',
      title: 'Connessi ma Sconnessi',
      left: { title: 'Online', items: ['500 amici su Instagram', 'Like e commenti', 'Vite perfette filtrate', 'Disponibili 24/7'] },
      right: { title: 'Offline', items: ['Soli nella propria stanza', 'Disturbi dell\'attenzione', 'Ansia sociale', 'Nessun punto di riferimento'] }
    },
    {
      type: 'solution',
      title: 'La Soluzione: AI_COVO',
      items: [
        { icon: '📚', title: 'Doposcuola', desc: 'Ogni pomeriggio, 14:00-18:00' },
        { icon: '💻', title: 'Formazione Digitale', desc: 'Corsi per tutte le età' },
        { icon: '👴', title: 'Intergenerazionale', desc: 'Anziani e giovani insieme' },
        { icon: '🏠', title: 'Spazi Condivisi', desc: 'Un luogo dove esistere' }
      ]
    },
    {
      type: 'impact',
      title: 'L\'Impatto',
      quote: '"Non hanno più qualcuno che crede in loro e gli dà una possibilità."',
      highlight: 'Lo faremo noi.',
      beneficiari: ['Adolescenti', 'Famiglie ISEE basso', 'Anziani soli', 'Immigrati', 'Chi dorme in auto']
    },
    {
      type: 'model',
      title: 'Un Modello Replicabile',
      content: 'Come McDonald\'s ha le sue linee guida, AI_COVO offre uno statuto, un logo e regole precise per ogni comune italiano.',
      target: '8.000+ comuni potenziali'
    },
    {
      type: 'vision',
      title: 'Il Primo Comune Inclusivo e Sociale d\'Italia',
      content: 'Colle Val d\'Elsa non ha vinto la Capitale della Cultura 2028. Ma può diventare qualcosa di ancora più grande: il primo Comune Inclusivo e Sociale d\'Italia. Un precedente.',
      highlight: 'Lo faremo insieme, 1\u20AC alla volta, grazie al contributo di tutti i colligiani.',
      ministry: 'Un modello che merita l\'attenzione del Ministro delle Pari Opportunit\u00E0, Cultura, Associazionismo, Immigrazione. Saranno loro a provvedere al mantenimento dei POLI in ogni citt\u00E0.',
      urgency: 'Ci sono adolescenti in pericolo da Aosta a Catania. Basta decidere che ogni italiano dona 1\u20AC al mese per un progetto che pu\u00F2 ritorcersi contro in meglio in qualsiasi momento della loro vita come cittadini.'
    },
    {
      type: 'ask',
      title: 'Cosa Chiediamo',
      primary: { amount: '19€', desc: 'Quota socio fondatore' },
      goal: '1.000 cittadini × 19€ = €19.000',
      includes: ['Tessera socio', 'T-shirt personalizzata', 'Portachiavi edizione limitata']
    },
    {
      type: 'cta',
      title: 'Unisciti a Noi',
      message: 'Saranno loro a prendersi cura di voi.',
      website: 'aicovo.tech',
      hashtag: '#AI_COVO'
    }
  ];

  return (
    <main data-testid="pitch-page" className="pt-24 pb-16">
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12 flex justify-between items-center">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-2">Pitch Deck</p>
            <h1 className="text-3xl font-bold">Presentazione TEDx Style</h1>
          </div>
          <Link to="/dona" className="btn-primary bg-[#00FF41] text-black border-[#00FF41]">
            Sostieni - 19€
          </Link>
        </div>

        <div className="space-y-8">
          {slides.map((slide, i) => (
            <div 
              key={i} 
              className="bg-[#0A0A0A] border border-white/10 p-8 md:p-12 min-h-[400px] flex flex-col justify-center"
              data-testid={`slide-${i}`}
            >
              <p className="font-mono text-xs text-zinc-600 mb-6">SLIDE {String(i + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}</p>
              
              {slide.type === 'title' && (
                <div className="text-center">
                  <h2 className="text-5xl md:text-7xl font-black text-[#00FF41] neon-glow mb-4">{slide.title}</h2>
                  <p className="text-2xl md:text-3xl font-bold text-white mb-4">{slide.subtitle}</p>
                  <p className="text-zinc-500">{slide.tagline}</p>
                </div>
              )}

              {slide.type === 'question' && (
                <div className="text-center">
                  <h2 className="text-4xl md:text-6xl font-black text-white mb-8">{slide.title}</h2>
                  <p className="text-xl text-zinc-400 mb-6">{slide.content}</p>
                  <p className="text-2xl text-[#00FF41] font-bold">{slide.highlight}</p>
                </div>
              )}

              {slide.type === 'problem' && (
                <div>
                  <h2 className="text-3xl font-bold text-white mb-12 text-center">{slide.title}</h2>
                  <div className="grid md:grid-cols-3 gap-8">
                    {slide.stats.map((stat, j) => (
                      <div key={j} className="text-center">
                        <p className="text-6xl font-black text-[#00FF41]">{stat.number}</p>
                        <p className="text-xl text-white font-bold">{stat.label}</p>
                        <p className="text-zinc-500 mt-2">{stat.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {slide.type === 'contrast' && (
                <div>
                  <h2 className="text-3xl font-bold text-white mb-12 text-center">{slide.title}</h2>
                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="bg-blue-500/10 border border-blue-500/30 p-6">
                      <h3 className="text-xl font-bold text-blue-400 mb-4">{slide.left.title}</h3>
                      <ul className="space-y-2">
                        {slide.left.items.map((item, j) => (
                          <li key={j} className="text-zinc-300">✓ {item}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="bg-red-500/10 border border-red-500/30 p-6">
                      <h3 className="text-xl font-bold text-red-400 mb-4">{slide.right.title}</h3>
                      <ul className="space-y-2">
                        {slide.right.items.map((item, j) => (
                          <li key={j} className="text-zinc-300">✗ {item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {slide.type === 'solution' && (
                <div>
                  <h2 className="text-3xl font-bold text-[#00FF41] mb-12 text-center">{slide.title}</h2>
                  <div className="grid md:grid-cols-2 gap-6">
                    {slide.items.map((item, j) => (
                      <div key={j} className="flex items-start gap-4 p-4 border border-white/10">
                        <span className="text-3xl">{item.icon}</span>
                        <div>
                          <h3 className="text-lg font-bold text-white">{item.title}</h3>
                          <p className="text-zinc-400 text-sm">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {slide.type === 'impact' && (
                <div className="text-center">
                  <h2 className="text-3xl font-bold text-white mb-8">{slide.title}</h2>
                  <blockquote className="text-xl text-zinc-400 italic mb-4">{slide.quote}</blockquote>
                  <p className="text-3xl text-[#00FF41] font-black mb-8">{slide.highlight}</p>
                  <div className="flex flex-wrap justify-center gap-3">
                    {slide.beneficiari.map((b, j) => (
                      <span key={j} className="px-4 py-2 bg-white/5 border border-white/10 text-sm">{b}</span>
                    ))}
                  </div>
                </div>
              )}

              {slide.type === 'model' && (
                <div className="text-center">
                  <h2 className="text-3xl font-bold text-white mb-8">{slide.title}</h2>
                  <p className="text-xl text-zinc-400 mb-8 max-w-2xl mx-auto">{slide.content}</p>
                  <p className="text-4xl font-black text-[#00FF41]">{slide.target}</p>
                </div>
              )}

              {slide.type === 'vision' && (
                <div className="text-center">
                  <h2 className="text-3xl md:text-4xl font-black text-[#00FF41] mb-8">{slide.title}</h2>
                  <p className="text-xl text-zinc-300 mb-6 max-w-3xl mx-auto leading-relaxed">{slide.content}</p>
                  <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-6 mb-8 max-w-2xl mx-auto">
                    <p className="text-lg text-white font-bold italic">{slide.highlight}</p>
                  </div>
                  <p className="text-zinc-400 mb-4 max-w-2xl mx-auto">{slide.ministry}</p>
                  <div className="border-l-4 border-[#00FF41] pl-6 text-left max-w-2xl mx-auto mt-8">
                    <p className="text-zinc-300 leading-relaxed">{slide.urgency}</p>
                  </div>
                </div>
              )}

              {slide.type === 'ask' && (
                <div className="text-center">
                  <h2 className="text-3xl font-bold text-white mb-8">{slide.title}</h2>
                  <p className="text-7xl font-black text-[#00FF41] mb-2">{slide.primary.amount}</p>
                  <p className="text-xl text-zinc-400 mb-8">{slide.primary.desc}</p>
                  <p className="text-2xl text-white font-bold mb-8">{slide.goal}</p>
                  <div className="flex flex-wrap justify-center gap-4">
                    {slide.includes.map((item, j) => (
                      <span key={j} className="px-4 py-2 bg-[#00FF41]/10 border border-[#00FF41]/30 text-[#00FF41]">✓ {item}</span>
                    ))}
                  </div>
                </div>
              )}

              {slide.type === 'cta' && (
                <div className="text-center">
                  <h2 className="text-4xl font-bold text-[#00FF41] mb-6">{slide.title}</h2>
                  <p className="text-2xl text-white mb-8">{slide.message}</p>
                  <p className="text-3xl font-mono text-zinc-400 mb-4">{slide.website}</p>
                  <p className="text-xl text-[#00FF41]">{slide.hashtag}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-zinc-500 mb-4">Scarica la presentazione</p>
          <button className="btn-primary">Download PDF (coming soon)</button>
        </div>
      </div>
    </main>
  );
};

export default PitchPage;
